<template>
  <div v-if="queueCount === 0">
    <ImportFinanceStageSidebar :importInfo="importInfo" @update-queue="updateQueueData($event)"  @update-stage="$emit('update-stage')"/>
  </div>
  <div v-else class="content-full-page import-source-stage-post-sending">
    <div class="block-loading"/>
    {{`Осталось объектов в очереди ${queueCount}...`}}
  </div>
</template>

<script>
  import ImportFinanceStageSidebar from "./ImportFinanceStageSidebar";

  export default {
    name: "ImportFinanceStage",
    props: {
      importInfo: {},
    },
    data() {
      return {
        queueCount: 0,
        queueTimer: null
      }
    },
    components: {
      ImportFinanceStageSidebar
    },
    created() {
      this.updateQueueData();
    },
    methods: {
      updateQueueData(debts = false) {
        this.updateQueueCount(debts);
        this.setTimer(debts);
      },
      async updateQueueCount(debts) {
        try {
          let params = {};
          if(debts){
            params.debts = true;
          }
          let {data} = await this.$http.get('import/houses/queue_status', {params: params});
          this.queueCount = data.queued_tasks_count;
          if (data.queued_tasks_count < 1) {
            this.clearTimer();
          }
        } catch (e) {
          this.$vs.notify({color: 'danger', title: 'ERROR', text: e.message});
        }
      },
      setTimer(debts = false) {
        this.queueTimer = setInterval(() => {
          this.updateQueueCount(debts);
        }, 10000);
      },
      clearTimer() {
        clearInterval(this.queueTimer);
        this.queueTimer = null;
        this.queueCount = 0;
      }
    },
    beforeDestroy() {
      this.clearTimer();
    }
  }
</script>

<style lang="scss">
  .import-source-stage-post-sending {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .block-loading {
      width: 100px;
      height: 100px;
      flex: 0;
      margin-bottom: 15px;
    }
  }
</style>